import { collection } from "@firebase/firestore";
import { useContext, useMemo } from "react";
import { useCollectionOnce } from "react-firebase-hooks/firestore";
import { FirebaseContext } from "./firebase";

// Same shape as useSimpleCollection, but reads the collection a single time
// instead of keeping a realtime listener open. Use for one-off reads where
// live updates are unnecessary (e.g. admin reports).
export const useSimpleCollectionOnce = <T>(path: string): [T[], boolean, Error] => {
  const { firestore } = useContext(FirebaseContext);
  const [snapshot, loading, error] = useCollectionOnce(collection(firestore, path));
  const data = useMemo(() => {
    if (!snapshot) return [];
    return snapshot.docs.map((doc) => {
      const data = doc.data();
      const dataWithId = { ...data, id: doc?.id } as T;
      return dataWithId;
    });
  }, [snapshot]);

  return [data, loading, error];
};
